import React from 'react'
import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import Navigation_ButtonHint from "../components/hint/hint-section";
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";
import Workspace from "../../../core/model2/space/workspaces/workspace";
import ProjectIconUI5 from "../../../core/gd-components/icons/project/project-icon-ui5";
import Navigation_BaseButton from "./base-button";
import getWorkspaceIconClass from "./actions/get-workspace-icon-class";
import {UIType} from "../../ui/@const";
import {ItemIconSize} from "../../../core/gd-components/icons/@const";

type Props = {
    className?          : string,

    section             : NavigationSection,

    inMorePopover       : boolean

    onClickCallback?    : callback

} & ReorderItemProps

// const debug = "Navigation_ButtonWorkspace"
const debug = false

export default class Navigation_ButtonWorkspace extends React.Component<Props> {
    // public refHint                  : React.RefObject<NavigationHint> = React.createRef<NavigationHint>()
    public refHint                  : React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    componentWillUnmount() {
        if (gd.layout.contextMenu.hover?.component === this) {
            gd.layout.contextMenu.hover.component = null
            gd.layout.contextMenu.hide()
        }
    }

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        let options : Option[] = []

        if (this.props.section.space?.isWorkspace) {
            options.push({
                label       : "Info",
                icon        : 'ii5-information',
                onClick     : () => {
                    const workspace: Workspace = this.props.section.space as Workspace
                    workspace.project.goToInfo()
                }
            })
        }

        options = options.concat(this.props.section.positionOptions)

        if (_.size(options) < 1) {
            return null
        }

        debug && console.log(debug, 'showContextMenu', e)

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {options}
                         hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this
            }
        )
    }

    onClick = (e:React.MouseEvent) => {
        debug && console.log(debug, 'onClick', e)

        e.stopPropagation()

        if (this.props.onClickCallback) this.props.onClickCallback()

        this.refHint?.current?.hideHint()

        this.props.section.onClick && this.props.section.onClick(this.props.section)
    }

    render() {
        const isSelected = gd.layout.navigation.state.currentSection?.id === this.props.section.id   // yes by id not object

        const {defaultIconColorClass, selectedIconColorClass} = getWorkspaceIconClass()

        debug && console.log(debug, 'render', this.props.section.name, isSelected, this.props.isMouseEntered, this.props, (isSelected || this.props.isMouseEntered) ? selectedIconColorClass : defaultIconColorClass)

        const showHintButton = !this.props.inMorePopover && !this.props.dndIsDragInProgress

        // style is required for ReorderList (pointer-events: none)
        return (
            <Navigation_BaseButton
                className           = {this.props.className}
                style               = {this.props.style}
                label               = {this.props.section.name}
                isSelected          = {isSelected}
                dndPreview          = {this.props.dndPreview}
                dndIsDragged        = {this.props.dndIsDragged}
                inMorePopover       = {this.props.inMorePopover}
                dndIsDragInProgress = {this.props.dndIsDragInProgress}
                isMouseEntered      = {this.props.isMouseEntered}
                onClick             = {this.onClick}
                showContextMenu     = {this.showContextMenu}
            >
                <ProjectIconUI5
                    className   = {(isSelected || this.props.isMouseEntered) ? selectedIconColorClass : defaultIconColorClass}
                    project     = {this.props.section.workspace}
                    size        = {gd.ui.type === UIType.GOODDAY_MODERN ? ItemIconSize.SIZE_17 : ItemIconSize.SIZE_18}
                />

                {showHintButton &&
                    <Navigation_ButtonHint
                        ref     = {this.refHint}
                        section = {this.props.section}
                    />
                }
            </Navigation_BaseButton>
        )
    }
}
